type DataAlertProps = {
  updateDefault: () => void;
  original?: unknown;
};

function DataAlert({ updateDefault, original }: DataAlertProps): JSX.Element {
  const text = (): string | null => {
    if (original !== undefined && original !== null && String(original).length > 0) {
      return `Original value: ${String(original)}`;
    }
    return null;
  };

  return (
    <>
      <span className="ml-2" style={{ cursor: "pointer" }} onClick={updateDefault}>
        <i className="text-warning icon-circle-solid"></i>
      </span>
      <span className="ml-2">{text()}</span>
    </>
  );
}

export default DataAlert;
